/* eslint-disable react/no-find-dom-node */
import { Component } from 'react'
import { findDOMNode } from 'react-dom'
import { subscribe } from 'subscribe-ui-event'

let isGlobalListenersRegistered = false
let lastUserEvent = 'pointer'

function handleClickEvents() {
  lastUserEvent = 'pointer'
}

function handleWheelEvents() {
  lastUserEvent = 'wheel'
}

function registerGlobalListeners() {
  if (!isGlobalListenersRegistered) {
    window.addEventListener('click', handleClickEvents)
    window.addEventListener('wheel', handleWheelEvents, {
      passive: true,
    })
    window.addEventListener('mousewheel', handleWheelEvents, {
      passive: true,
    })
    window.addEventListener('touchmove', handleWheelEvents, {
      passive: true,
    })
    isGlobalListenersRegistered = true
  }
}

class ScrollObserver extends Component {
  static defaultProps = {
    threshold: 1,
    useRAF: true,
    emitOnce: true,
  }

  state = { bottom: 0 }

  componentDidMount() {
    this.node = findDOMNode(this)

    registerGlobalListeners()
    const { throttleRate, useRAF } = this.props
    const position = window.pageYOffset

    this.startPosition = position
    this.previousPosition = position
    this.subscription = subscribe('scroll', this.handleScroll, {
      throttleRate,
      useRAF,
    })
  }

  componentWillUnmount() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  currentDirection = null
  lastEmitDirection = null
  startPosition = 0
  previousPosition = 0

  handleScrollToLimit = direction => {
    const { onScrollToBottom, onScrollToTop } = this.props

    const { bottom } = this.node.getBoundingClientRect()

    if (
      direction === 'down' &&
      this.state.bottom > window.innerHeight &&
      bottom <= window.innerHeight &&
      onScrollToBottom
    ) {
      onScrollToBottom()
    }

    if (
      direction === 'up' &&
      this.state.bottom < window.innerHeight &&
      bottom >= window.innerHeight &&
      onScrollToTop
    ) {
      onScrollToTop()
    }

    this.setState({ bottom })
  }

  handleScrolMoment = direction => {
    const { emitOnce, onScrollUp, onScrollDown } = this.props

    if (
      lastUserEvent === 'wheel' &&
      (!emitOnce || this.lastEmitDirection !== direction)
    ) {
      const scrollHandlers = {
        up: onScrollUp,
        down: onScrollDown,
      }

      if (scrollHandlers[direction]) {
        scrollHandlers[direction]()
      }
    }
  }

  handleScrollAction = (direction, position) => {
    if (Math.abs(this.startPosition - position) >= this.props.threshold) {
      this.handleScrollToLimit(direction)
      this.handleScrolMoment(direction)

      this.lastEmitDirection = direction
      this.startPosition = position
    }
  }

  handleScroll = () => {
    const position = window.pageYOffset

    /**
     * safari 下（-webkit-overflow-scrolling: touch）
     * window.pageYOffset 有负值，屏蔽事件
     * */
    if (position < 0) {
      return
    }

    const direction = position < this.previousPosition ? 'up' : 'down'

    if (direction !== this.currentDirection) {
      this.currentDirection = direction
      this.startPosition = this.previousPosition
    }

    this.previousPosition = position

    this.handleScrollAction(direction, position)
  }

  render() {
    return this.props.children || null
  }
}

export default ScrollObserver



// WEBPACK FOOTER //
// ./src/components/ScrollObserver.js